import { ApolloProvider } from "@apollo/client";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { apolloClient } from "./lib/apollo-client";
import {
  CentralBaseSelector,
  CentralRedirectSplash,
} from "./components/central/CentralBaseSelector";
import {
  clearSavedBaseSlug,
  getCentralEnv,
  getSavedBaseSlug,
  redirectToBase,
  TROCAR_PARAM,
} from "./lib/tenant-host";
import "./styles/global.css";

// const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
// if (SENTRY_DSN) {
//   Sentry.init({
//     dsn: SENTRY_DSN,
//     sendDefaultPii: true,
//     environment: import.meta.env.MODE,
//     enabled: import.meta.env.MODE !== "test",
//     // Aumentar sample rate para homologação
//     // replaysSessionSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
//     // replaysOnErrorSampleRate: 1.0,
//     release: import.meta.env.VITE_APP_VERSION,
//     // Debug para homologação
//     // debug: import.meta.env.MODE !== 'production',
//     tracesSampleRate: 1.0,
//     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//     integrations: [
//       Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
//       // Sentry.replayIntegration(),
//       Sentry.browserTracingIntegration(),
//       Sentry.graphqlClientIntegration({
//         endpoints: [
//           "localhost",
//           /^\//,
//           "https://api-v2.escolarai.com.br/graphql",
//           "https://api.escolarai.com.br/graphql",
//           /\/graphql$/,
//         ],
//       }),
//       Sentry.feedbackIntegration({
//         // Additional SDK configuration goes in here, for example:
//         colorScheme: "system",
//         showName: false,
//         showEmail: false,
//         showBranding: false,
//         // Auto inject para homologação/desenvolvimento
//         // Configurações de rede
//         networkRequestTimeout: 30000, // 30s timeout
//         triggerLabel: "Reportar problema",
//         triggerLabelInDialog: "Reportar problema",
//         formTitle: "Reportar problema",
//         submitButtonLabel: "Enviar",
//         cancelButtonLabel: "Cancelar",
//         confirmButtonLabel: "Confirmar",
//         addScreenshotButtonLabel: "Adicionar screenshot",
//         removeScreenshotButtonLabel: "Remover screenshot",
//         nameLabel: "Nome",
//         namePlaceholder: "Digite seu nome",
//         emailLabel: "Email",
//         emailPlaceholder: "Digite seu email",
//         isRequiredLabel: "Este campo é obrigatório",
//         messageLabel: "Mensagem",
//         messagePlaceholder: "Digite sua mensagem",
//         successMessageText: "Obrigado por nos ajudar a melhorar!",
//         useSentryUser: true,
//       }),
//     ],
//     // Enable logs to be sent to Sentry
//     enableLogs: true,
//     tracePropagationTargets: [
//       "localhost",
//       "https://api-v2.escolarai.com.br",
//       "https://api.escolarai.com.br",
//     ],
//   });
// }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// --- Gate multi-tenant ---------------------------------------------------
// Nas apex centrais (escolarai.com.br / front-v2.escolarai.com.br) não há base
// definida: o usuário precisa escolher a escola antes do app subir. Como a API
// resolve a base pelo subdomínio, aqui só selecionamos/persistimos e redirecionamos.
// Em qualquer outro host (base ou localhost) o app roda normalmente.
const centralEnv = getCentralEnv();

if (centralEnv) {
  const forcarTroca = new URLSearchParams(window.location.search).has(
    TROCAR_PARAM,
  );
  if (forcarTroca) clearSavedBaseSlug();

  const baseSalva = forcarTroca ? null : getSavedBaseSlug();

  if (baseSalva) {
    // Já escolheu antes (e não pediu pra trocar): vai direto pra base.
    redirectToBase(baseSalva, centralEnv);
    root.render(<CentralRedirectSplash />);
  } else {
    // Primeira vez (ou "trocar escola"): mostra o combo.
    root.render(
      <React.StrictMode>
        <CentralBaseSelector env={centralEnv} />
      </React.StrictMode>,
    );
  }
} else {
  root.render(
    <React.StrictMode>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </React.StrictMode>,
  );
}
